import isNumber from 'lodash/isNumber';

import { isNonEmptyString } from './isNonEmptyString';

/**
 * Reduces a value to its digits, as a string.
 *
 * Distinct from `stripNonNumericValues`, which keeps a decimal point and hands
 * a number straight back. This one is for the positional formatters
 * (`toDOBString`, `toPhoneString`, `toSSNString`), where a `.` surviving the
 * strip would be counted as a digit and shift every separator along.
 */
export const toDigits = (value?: string | number | null): string => {
  if (isNonEmptyString(value)) {
    return value.replace(/\D/g, '');
  }

  return isNumber(value) ? Math.abs(value).toString().replace(/\D/g, '') : '';
};
